<script>
import Draggable from 'vuedraggable';
import converter from '../../../utils/converter';
import SkiAreaSlopeMapsImage from './SkiAreaSlopeMapsImage';

export default {
  components: {
    SkiAreaSlopeMapsImage,
    Draggable,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    enableShuffle: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    shuffle() {
      this.$emit('shuffle', converter.arrayShuffle(this.images));
    },
    move({ moved }) {
      this.$emit('move', converter.arrayMove(this.images, moved.oldIndex, moved.newIndex));
    },
    remove(index) {
      this.$emit('remove', { image: this.images[index], images: this.images });
    },
  },
};
</script>

<template>
  <v-card>
    <v-container
      grid-list-sm
      fluid
      text-xs-center
    >
      <v-layout
        row
        wrap
        align-center
      >
        <div v-if="enableShuffle && images.length">
          <v-btn
            color="white"
            @click="shuffle">
            {{ $t('slopeMaps.shuffle') }}
          </v-btn>
        </div>
        <draggable
          :value="images"
          @change="move"
          class="xs12 ski-area-slope-maps-image-list-draggable"
        >
          <transition-group name="list-complete">
            <v-flex
              v-for="(image, index) in images"
              :key="image.large"
              class="ski-area-slope-maps-image-list-draggable-item"
              xs4
              d-flex
            >
              <v-card>
                <ski-area-slope-maps-image
                  :title="image.title"
                  :src="image.large || ''"
                  @update="$emit('update', {index: index, image: {...image, ...$event }})"
                  @remove="remove(index)"
                />
                <template v-slot:placeholder>
                  <v-layout
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  />
                </template>
              </v-card>
            </v-flex>
          </transition-group>
        </draggable>
        <v-flex
          v-if="!images.length && !error && !loading"
          xs12
          pa-5
        >
          <v-flex>
            <v-icon text--secondary>image</v-icon>
          </v-flex>
          <v-flex
            font-italic
            text--secondary
          >
            {{ $t('slopeMaps.imageListEmpty') }}
          </v-flex>
        </v-flex>
        <v-flex
          v-if="loading"
          xs12
          pa-5
        >
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          />
        </v-flex>
        <v-flex
          v-if="error"
          xs12
          pa-5
        >
          <v-flex>
            <v-icon text--secondary>warning</v-icon>
          </v-flex>
          <v-flex
            font-italic
            text--secondary
          >
            {{ $t('slopeMaps.imageListError') }}
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<style lang="scss">
  .ski-area-slope-maps-image-list-draggable {
    width: 100%;
  }

  .ski-area-slope-maps-image-list-draggable-item {
    float: left;
    width: calc((100% / 3) - 10px);
    margin: 5px;
    transition: all 1s;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/ski/areas/SkiAreaSlopeMapsImageList.vue